import consoleFourTrackers from './includes/console-four-trackers.js';
import fightcampQuickWraps from './includes/fightcamp-quick-wraps.js';
import fightcampAnkleWraps from './includes/fightcamp-ankle-wraps.js';
import fightcampBoxingBag from './includes/fightcamp-boxing-bag.js';
import fightcampBagRing from './includes/fightcamp-bag-ring.js';
import fightcampGloves from './includes/fightcamp-gloves.js';
import fightcampHeartRateMonitor from './includes/fightcamp-heart-rate-monitor.js';

export default [
  {
    testShopifyId: 'gid://shopify/Product/7977363996761',
    prodShopifyId: 'gid://shopify/Product/8945312432364',
    pathId: 'shop/products/fightcamp-connect',
    title: 'Connect',
    price: '$299',
    description: 'Elevate your boxing setup with FightCamp’s core technology. Ideal for those with a bag and gloves who only need the essentials.',
    includes: [
      consoleFourTrackers,
      fightcampQuickWraps,
      fightcampAnkleWraps,
    ],
    includesBag: false,
    assets: [
      {
        src: 'https://a.storyblok.com/f/152150/800x800/1173821e7c/connect_package.jpg',
        alt: 'FightCamp Package',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1000x1000/bc0d46e6ff/fc-punch.jpg',
        alt: 'FightCamp user punching free standing bag',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1000x1000/95f35dd971/fc-partner-workout.jpg',
        alt: 'FightCamp partner workout',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/2085a1b94c/fc-product-carousel-4.jpg',
        alt: 'FightCamp quick wraps with trackers',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/a5b659c1ff/fc-product-carousel-5.jpg',
        alt: 'Person working out with FightCamp',
      },
    ],
  },
  {
    testShopifyId: 'gid://shopify/Product/7977374154841',
    prodShopifyId: 'gid://shopify/Product/8945313054956',
    pathId: 'shop/products/fightcamp-complete',
    title: 'Complete',
    price: '$699',
    description: 'The ideal starter kit. Includes everything you need to transform any room into your personal boxing gym with our premium gear and tech.',
    includes: [
      consoleFourTrackers,
      fightcampQuickWraps,
      fightcampAnkleWraps,
      fightcampBoxingBag,
    ],
    includesBag: true,
    assets: [
      {
        src: 'https://a.storyblok.com/f/152150/800x800/28dab8193a/complete_package_v2.jpg',
        alt: 'FightCamp Package',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1000x1000/bc0d46e6ff/fc-punch.jpg',
        alt: 'FightCamp user punching free standing bag',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1000x1000/95f35dd971/fc-partner-workout.jpg',
        alt: 'FightCamp partner workout',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/2085a1b94c/fc-product-carousel-4.jpg',
        alt: 'FightCamp quick wraps with trackers',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/a5b659c1ff/fc-product-carousel-5.jpg',
        alt: 'Person working out with FightCamp',
      },
    ],
  },
  {
    testShopifyId: 'gid://shopify/Product/7977374220377',
    prodShopifyId: 'gid://shopify/Product/8945313317100',
    pathId: 'shop/products/fightcamp-elite',
    title: 'Elite',
    price: '$899',
    description: 'The full FightCamp package. Premium gear, tech, and everything you\'ll need for the most immersive at home training.',
    includes: [
      consoleFourTrackers,
      fightcampQuickWraps,
      fightcampAnkleWraps,
      fightcampBoxingBag,
      fightcampBagRing,
      fightcampGloves,
      fightcampHeartRateMonitor,
    ],
    includesBag: true,
    assets: [
      {
        src: 'https://a.storyblok.com/f/152150/800x800/3539b8a2ff/elite_package_v5.jpg',
        alt: 'FightCamp Package',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1000x1000/bc0d46e6ff/fc-punch.jpg',
        alt: 'FightCamp user punching free standing bag',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1000x1000/95f35dd971/fc-partner-workout.jpg',
        alt: 'FightCamp partner workout',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/2085a1b94c/fc-product-carousel-4.jpg',
        alt: 'FightCamp quick wraps with trackers',
      },
      {
        src: 'https://a.storyblok.com/f/152150/1001x1000/a5b659c1ff/fc-product-carousel-5.jpg',
        alt: 'Person working out with FightCamp',
      },
    ],
  },
];
